/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DecreaseInputs */



/**
* | output |
* | --- |
* | "Decrease" |
*
* @param {Common_DecreaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_decrease = /** @type {((inputs?: Common_DecreaseInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DecreaseInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Diminuir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diminuisci")
	return /** @type {LocalizedString} */ ("Decrease")
});